import React, { useEffect } from "react";
import styled from "styled-components";


const Details = styled.div`
    font-size: 15px;
    font-family: 'Inter';
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 14px;
    margin-left: 0px;
`;


export default function ProfileDetails({title, value}){
    return (
        <Details>            
            <span>{value}</span>
            <span style={{color: '#60606F'}}>{title}</span>
        </Details>
    );
  };